export default "__VITE_PUBLIC_ASSET__63aeb946__"